import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActionButtonsComponent } from '@modules/shared/action-buttons/action-buttons.component';
import { CardDetailsComponent } from '@modules/shared/card-details/card-details.component';
import { ShowIfUserAuthorizedDirective } from '@modules/shared/directives/show-if-user-authorized.directive';
import { Patient } from '@pixacare/domain';
import { LastActivityPipe } from '@shared/pipes/last-activity.pipe';
import { TuiBadge, TuiStatus } from '@taiga-ui/kit';
import { MenuAction } from 'src/app/shared/models/menu-actions/menu-action';
import { PatientAvatarComponent } from '../patient-avatar/patient-avatar.component';
import { PatientDataComponent } from '../patient-data/patient-data.component';

@Component({
  selector: 'pxc-patient-card',
  templateUrl: './patient-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CardDetailsComponent,
    PatientDataComponent,
    TuiBadge,
    TuiStatus,
    LastActivityPipe,
    ActionButtonsComponent,
    ShowIfUserAuthorizedDirective,
    PatientAvatarComponent,
  ],
  host: {
    class: 'relative ml-4',
  },
})
export class PatientCardComponent {
  @Input() patient: Patient;
  @Input() actions: MenuAction<Patient>[];
  @Input() displayLastActivity = false;
}
